import { Snowflake, Sparkles, ArrowUpRight } from "lucide-react";
import Snowfall from "./Snowfall";
import { Reveal, GoldButton, Logo } from "./shared";
import { BOOKING_URL, ADDRESS, NAV_LINKS } from "./content";

export function FinalCta() {
    return (
        <section className="relative overflow-hidden bg-wine py-24 sm:py-28" data-testid="final-cta-section">
            <Snowfall count={40} />
            <div
                className="absolute inset-0"
                style={{ background: "radial-gradient(800px 400px at 50% 110%, rgba(212,175,55,0.2), transparent 65%)" }}
            />
            <div className="relative z-10 mx-auto max-w-4xl px-5 text-center sm:px-8">
                <Reveal>
                    <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-gold-light">
                        Earlybird £49 · Limited Christmas Slots
                    </p>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-6 font-serif text-4xl font-bold leading-[1.06] tracking-tight text-cream sm:text-5xl lg:text-6xl">
                        Christmas books out fast.
                        <span className="block italic text-goldgrad">Lock in the best rate.</span>
                    </h2>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-cream/85 sm:text-lg">
                        Our earlybird rate is here for a moment, then it's gone. Book your slot on
                        both sets before the calendar fills up.
                    </p>
                </Reveal>
                <Reveal delay={0.3}>
                    <GoldButton href={BOOKING_URL} testId="final-cta-button" className="mt-10 px-10 py-5 text-base">
                        <Sparkles className="h-5 w-5" />
                        Book Earlybird for £49
                    </GoldButton>
                </Reveal>
            </div>
        </section>
    );
}

export function Footer() {
    return (
        <footer className="border-t border-gold/15 bg-pine-950 py-14">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
                    <div>
                        <Logo />
                        <address className="mt-4 text-sm not-italic leading-relaxed text-mist" data-testid="footer-address">
                            {ADDRESS.full}
                        </address>
                    </div>
                    <nav className="flex flex-wrap gap-x-6 gap-y-2" aria-label="Footer">
                        {NAV_LINKS.map((l) => (
                            <a
                                key={l.href}
                                href={l.href}
                                className="text-[13px] uppercase tracking-[0.16em] text-mist transition-colors hover:text-gold"
                            >
                                {l.label}
                            </a>
                        ))}
                    </nav>
                    <a
                        href={BOOKING_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="footer-book-link"
                        className="inline-flex items-center gap-1.5 text-sm font-semibold text-gold hover:text-gold-light"
                    >
                        Book earlybird £49
                        <ArrowUpRight className="h-4 w-4" />
                    </a>
                </div>
                <div className="mt-10 flex flex-col gap-2 border-t border-gold/10 pt-6 text-xs text-mist/70 sm:flex-row sm:items-center sm:justify-between">
                    <p>© {new Date().getFullYear()} Essex Photography Studio by WVE Studios · Christmas mini sessions</p>
                    <p className="flex items-center gap-2">
                        <Snowflake className="h-3.5 w-3.5 text-gold/70" />
                        See you in the snow
                    </p>
                </div>
            </div>
        </footer>
    );
}

export function StickyMobileBar() {
    return (
        <div
            className="fixed inset-x-3 bottom-3 z-50 md:hidden"
            data-testid="sticky-mobile-cta"
        >
            <div className="glass-card flex items-center justify-between gap-3 rounded-2xl p-3 pl-5 shadow-[0_16px_40px_rgba(0,0,0,0.5)]">
                <div>
                    <span className="block font-serif text-xl font-bold leading-none text-cream">£49</span>
                    <span className="block font-mono text-[9px] uppercase tracking-[0.2em] text-gold">
                        earlybird session
                    </span>
                </div>
                <a
                    href={BOOKING_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="sticky-mobile-cta-button"
                    className="rounded-full bg-gold px-6 py-3 text-xs font-bold uppercase tracking-[0.12em] text-pine-950"
                >
                    Book now
                </a>
            </div>
        </div>
    );
}
